<template>
  <div class="view orders">
    <div class="container">
      <h1 class="h2">Mes billets</h1>

      <loader v-if="loading" />
      <template v-else>
        <div
          v-if="orders && orders.length > 0"
          class="orders-list"
        >
          <order
            v-for="(order, index) in orders"
            :key="`order-${order.eventid}-${index}`"
            :order="order"
            @position="position"
          />
        </div>
        <p
          v-else
          class="orders-noresult"
        >
          Aucun billet à afficher
        </p>
        <!-- <p class="orders-bottomline"> Si vous venez de passer commande, il se peut que les billets de cette commande prennent un peu de temps avant d'apparaitre.</p> -->
      </template>
    </div>

    <div
      v-if="ticket"
      class="orders-popup"
    >
      <div class="orders-popup-wrapper">
        <h2 class="orders-popup-title h3">{{ ticket.attraction }}</h2>

        <div class="orders-popup-place">
          <span
            v-if="ticket.title"
            class="orders-popup-sit"
          >
            <span>{{ ticket.title }}</span>
          </span>

          <span class="orders-popup-category">{{ ticket.category }}</span>
        </div>
        <img
          :src="`https://sapiti.net/v1/accesscontrol/qrcode/${ticket.qrcode}`"
          class="orders-popup-qr"
        />
      </div>
      <button
        class="orders-popup-close"
        @click="closeTicket"
      >
        <sprite
          :type="'close'"
          :width="20"
          :height="20"
        />
      </button>
    </div>
  </div>
</template>

<script>
import Sprite from '@/components/components/Sprite.vue';
import Loader from '@/components/components/Loader.vue';
import Order from '@/components/modules/Order.vue';

export default {
  components: {
    Sprite,
    Loader,
    Order
  },
  beforeMount() {
    if (!this.$store.state.login.logged) {
      this.$store.commit('login/updateRedirect', '/orders');
      this.$router.push('/login');
      return;
    }

    if (!this.loading) {
      this.$store.dispatch('profile/getOrders');
    }
  },
  // mounted() {
  //   window.addEventListener('scroll', this.scroll);
  // },
  // beforeDestroy() {
  //   window.removeEventListener('scroll', this.scroll);
  // },
  data() {
    return {
      scroll: this.onScroll.bind(this),
      positionFromTicket: null,
    };
  },
  computed: {
    orders() {
      return this.$store.state.profile.orders.items;
    },
    loading() {
      return this.$store.state.profile.requests !== 0;
    },
    noMore() {
      return this.$store.state.profile.orders.noMore;
    },
    ticket() {
      return this.$store.state.profile.orders.ticket;
    },
    // sortedOrders() {
    //   return this.orders.slice().sort((a, b) => new Date(b.date.full) - new Date(a.date.full));
    // }
  },
  methods: {
    onScroll() {
      const { scrollY, innerHeight } = window;
      const height = document.body.clientHeight;
      const scroll = scrollY + innerHeight;
      if (scroll >= height - 40) {
        if (!this.loading && !this.noMore) {
          this.$store.dispatch('profile/nextOrders');
        }
      }
    },
    position(value) {
      this.positionFromTicket = value;
    },
    closeTicket() {
      this.$store.commit('profile/setTicket', null);
      setTimeout(() => {
        window.scrollTo(0, this.positionFromTicket);
      }, 2);
    }
  }
};
</script>

<style lang="scss" scoped>
.orders {
  @include padding(null null 38px);

  &-list {
    @include margin(24px null null);
  }

  .order {
    + .order {
      @include margin(24px null null);
    }
  }

  &-noresult {
    margin-top: 16px;
    font-size: rem(22px);
    line-height: (26 / 24);
  }

  &-bottomline {
    @include margin(24px null null);
    font-size: rem(14px);
    line-height: (16 / 14);
  }

  .loader {
    @include padding(30px null);
  }

  &-popup {
    @include position(fixed, 0 null null 0);
    @include size(100%);
    z-index: 1003;

    &-wrapper {
      @include position(absolute, 50% null null 50%);
      @include size(100%);
      @include padding(20px);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      z-index: 1;
      transform: translate(-50%, -50%);
      background-color: $black;
    }

    &-title {
      @include line-clamp(2, 26px, false);
      text-align: center;
    }

    &-place {
      margin-top: 12px;
      display: flex;
      align-items: center;
    }

    &-sit {
      @include font('secondary', 'regular');
      @include margin(null 16px null null);
      @include size(53px);
      display: flex;
      position: relative;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      background-color: $black-lighter;
      border-radius: 50%;
      font-size: rem(16px);
      line-height: (23 / 19);

      span {
        @include position(absolute, 50% null null 0);
        @include padding(2px null null);
        @include size(100%, auto);
        transform: translateY(-50%);
        text-align: center;
      }
    }

    &-category {
      @include font('secondary', 'regular');
      font-size: rem(16px);
      line-height: (23 / 19);
      text-align: center;
    }

    &-qr {
      max-width: 100%;
      height: auto !important;
      margin-top: 32px;
    }

    &-close {
      @include position(absolute, 0 0 null null);
      @include padding(20px);
      z-index: 2;

      .svg {
        display: block;
        fill: $white;
      }
    }
  }
}
</style>
